/**
 * Open a notification on THIS portal.
 *
 * The resolver hands back { url, space, mustSwitchSpace }. On Nucleus the URL
 * carries the group (/group/<id>/…), so a caller can ignore the other two. This
 * portal carries its group in sessionStorage.activeGroupId and nowhere in the
 * URL — so here the switch is the whole mechanism, and `navigate(to.url)` on its
 * own opens the right page in the wrong group. That is exactly what it did: a
 * group-owned app's key rotation reached the right admins and, when one clicked
 * it, landed on their personal apps list where that app does not exist.
 *
 * Pure, so it can be tested without rendering the shell.
 */
export function openNotification(to, { navigate, switchToGroup, switchToPersonal }) {
  if (!to || !to.url) return;

  if (to.mustSwitchSpace) {
    if (to.space && to.space !== 'personal') switchToGroup(to.space);
    else switchToPersonal();
  }
  navigate(to.url);
}
